import { PRODUCT_TYPE_CUSTOM, BUNDLE_PRODUCT } from 'src/utils/constant'

/**
 * @param {Object} bundle - The bundle object containing bundleMandatoryProducts and type
 * @returns {boolean} True if bundle is type 'bundle' (not 'kit') and has any Device product, false otherwise
 */
export const hasBundleDevice = bundle => {
  // Explicit null guard: bundle or bundle.type must exist before proceeding
  if (!bundle?.type) return false

  // Must be explicitly a 'bundle' type (not 'kit', not other)
  const bundleType = String(bundle.type).toLowerCase()
  if (bundleType !== BUNDLE_PRODUCT) {
    return false
  }

  if (!bundle?.bundleMandatoryProducts) return false

  return bundle.bundleMandatoryProducts.some(bundleProduct => {
    return (
      Array.isArray(bundleProduct.sku) &&
      bundleProduct.sku.some(sku => {
        const productTypeCustom = sku.properties?.productTypeCustom
        return (
          String(productTypeCustom).toLowerCase() === PRODUCT_TYPE_CUSTOM.DEVICE
        )
      })
    )
  })
}
